import {FormattedMessage} from 'react-intl';

const LEGEND_ITEMS = [
  {style: 'draft', label: 'time_tracking.shifts.legend.Draft'},
  {style: 'published', label: 'time_tracking.shifts.legend.Published'},
  {style: 'conflict', label: 'time_tracking.shifts.legend.Conflict'},
  {style: 'timeOff', label: 'time_tracking.shifts.legend.Time Off'}
];

const ScheduleLegend = () => {
  return (
    <div className='ShiftGrid-legend'>
      {LEGEND_ITEMS.map(({style, label}) => (
        <span key={style} className='ShiftGrid-legendItem'>
          <span className={`ShiftGrid-legendSwatch ShiftGrid-legendSwatch--${style}`}/>
          <FormattedMessage id={label}/>
        </span>
      ))}
      <span className='ShiftGrid-legendItem'>
        <i className='material-symbols-solid'>{'repeat'}</i>
        <FormattedMessage id='time_tracking.shifts.legend.Repeating'/>
      </span>
      <span className='ShiftGrid-legendItem'>
        <i className='material-symbols-solid'>{'sticky_note_2'}</i>
        <FormattedMessage id='time_tracking.shifts.legend.Note'/>
      </span>
    </div>
  );
};

export default ScheduleLegend;
